import { render, staticRenderFns } from "./NotProspectingSales.vue?vue&type=template&id=6429e9cc"
import script from "./NotProspectingSales.vue?vue&type=script&lang=js"
export * from "./NotProspectingSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports